import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import Blip from "../../../DesignSystem/Blip.vue";
import Icon from "../../../Icon/Icon.vue";
import {IconName} from "../../../Icon/icons";

interface Props {
  number: number;
  icon: IconName;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationControlItem',
  props: {
    number: {},
    icon: {}
  },
  emits: ['action'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function action(): void {
  emit('action');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative hover:text-green2-500 px-1 md:cursor-pointer",
    onClick: action
  }, [
    _createVNode(Icon, {
      name: props.icon,
      class: "size-10 text-xl text-center leading-10"
    }, null, 8 /* PROPS */, ["name"]),
    (props.number > 0)
      ? (_openBlock(), _createBlock(Blip, {
          key: 0,
          value: props.number,
          important: ""
        }, null, 8 /* PROPS */, ["value"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})